import Alert from '@mui/material/Alert'
import AlertTitle from '@mui/material/AlertTitle'

const ImportError = ({ error }) => {
  const toProperCase = (str) => {
    return str.replace(/\w\S*/g, function (txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
    })
  }

  return (
    <Alert severity="error">
      <AlertTitle>{toProperCase(error.type)} Error</AlertTitle>
      {error.error}
    </Alert>
  )
}

export default ImportError
